import { post } from "../utils/Backend";
import { useH5Mock } from "../global/GlobalMock";
import {
  mockCheckSpaceExists,
  mockRandomSpaceAccessConfig,
} from "./PlatformHomeMock";
import type { RandomSpaceAccessPublicConfig } from "./PlatformHomeType";

const checkSpaceExists = async (spaceId: string): Promise<boolean> => {
  if (useH5Mock) {
    return mockCheckSpaceExists(spaceId);
  }
  const res = await post<{ spaceId: string }, { exists: boolean }>(
    "/lark/app/space/checkSpaceExists",
    { spaceId },
    { silent: true }
  );
  if (typeof res === "string") {
    return false;
  }
  return !!res?.exists;
};

const getRandomSpaceAccessConfig = async (): Promise<RandomSpaceAccessPublicConfig> => {
  if (useH5Mock) {
    return mockRandomSpaceAccessConfig;
  }
  const res = await post<Record<string, never>, RandomSpaceAccessPublicConfig>(
    "/lark/app/home/getRandomSpaceAccessConfig",
    {},
    { silent: true }
  );
  if (typeof res === "string") {
    return { enabled: false, candidates: [] };
  }
  return {
    enabled: !!res?.enabled,
    candidates: Array.isArray(res?.candidates) ? res.candidates : [],
  };
};

export const PlatformHomeApi = {
  checkSpaceExists,
  getRandomSpaceAccessConfig,
};
